import {
  Spacing
} from 'UI'

export default theme => ({
  paperClass: {
    display: 'flex',
    flexDirection: 'column',
    height: ({ height }) => height,
    width: '100%',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 8
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 4,
      marginTop: 95
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.primary[1300],
      borderRadius: 10
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.primary[1200]
    }
  },
  headerClass: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: ({ learningMode, showAndHideController }) => showAndHideController ? 'flex-start' : learningMode ? 'flex-end' : 'space-between',
    padding: () => Spacing(5, 5, 4, 5),
    position: 'sticky',
    top: 0,
    zIndex: 1,
    background: theme.neutral[400]
  },
  controllerIcon: {
    color: theme.primary[0],
    backgroundColor: theme.neutral[0],
    borderRadius: 8,
    padding: 14,
    cursor: 'pointer'
  }
})
